import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { Map, fromJS } from 'immutable';

const INIT_STATE = Map({
    activeMenuItem: ''
})

function setActiveMenuItem(state, action){
    return state.set('activeMenuItem', action.payload.activeMenuItemID);
}


function websiteReducer(state = INIT_STATE, action) {
    
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.SETTINGS_SET_ACTIVE_MENUITEM:
            return setActiveMenuItem(state, action);
        default:
            return state;
    }
}

export default websiteReducer;